import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    updateList: null, // This will store the user data
};

const newUpdateSlice = createSlice({
    name: "newUpdate",
    initialState,
    reducers: {
        setUpdateList: (state, action) => {
            state.updateList = action.payload;
        },
        
    },

});

export const { setUpdateList } = newUpdateSlice.actions;
export default newUpdateSlice.reducer;
